<template>
  <transition
    @after-enter="afterEnter"
    @after-leave="afterLeave"
    @enter="enter"
    @leave="leave"
    name="page"
  >
    <slot></slot>
  </transition>
</template>

<script>
let p = document.getElementsByTagName('body')[0]
let h = document.getElementsByTagName('html')[0]
export default {
  name: 'LSlideYEnterTransition',
  methods: {
    enter (el) {
      if (p) {
        p.style.overflow = 'hidden'
        h.style.overflow = 'hidden'
      }
    },
    afterEnter (el) {
      if (p) {
        p.style.overflow = null
        h.style.overflow = null
      }
    },
    leave (el) {
      if (p) {
        p.style.overflow = 'hidden'
        h.style.overflow = 'hidden'
      }
    },
    afterLeave (el) {
      if (p) {
        p.style.overflow = null
        h.style.overflow = null
      }
    },
  },
}
</script>

<style scoped>
  .page-enter-active {
    transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  }

  .page-enter, .page-leave-to {
    transform: translateY(7px);
    opacity: 0;
  }
</style>
